import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=4cba1b22&scoped=true&"
import script from "./DownloadButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DownloadButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=4cba1b22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cba1b22",
  null
  
)

export default component.exports